module.exports = __webpack_public_path__ + "img/thank_2021_tip3_mall.7c425ae2.png";